/**
 * @module vuex/state
 */
export default {
    shoWdialogVisible: false,
    num:0,
    eventData:[],//时间数据集合,
}
